export const headerContent = {
  ctaDesktopLabel: "Zamów bezpłatną konsultację",
  ctaMobileLabel: "Zamów konsultację",
  mobileMenuAriaLabel: "Menu mobilne",
} as const;

export const blogListPageContent = {
  kicker: "Baza wiedzy",
  title: "Dostępność cyfrowa w praktyce",
  description:
    "Prawo, dane z audytów i metodologia - co naprawić, jak i w jakiej kolejności.",
  emptyState: "Brak artykułów.",
  ctaHeading: "Sprawdź jak wygląda Twoja strona",
  ctaDescription: "Bezpłatna konsultacja - 20 minut, bez zobowiązań.",
  ctaLabel: "Zamów bezpłatną konsultację",
} as const;

export const blogPostPageContent = {
  backToListLabel: "Wszystkie artykuły",
  readingTimeSuffix: "min czytania",
  nextStepKicker: "Następny krok",
  nextStepHeading: "Jak wygląda Twoja strona?",
  nextStepDescription:
    "Przeprowadzimy darmowy mini-audyt i pokażemy 3 najpoważniejsze naruszenia ustawy o dostępności cyfrowej - bez zobowiązań, w ciągu 48 h.",
  nextStepCtaLabel: "Zamów bezpłatną konsultację",
  relatedHeading: "Więcej artykułów",
} as const;

export const blogCardContent = {
  featuredBadgeLabel: "Wyróżniony",
  readLabel: "Czytaj",
  readMinutesShortSuffix: "min",
} as const;

export const appUiContent = {
  loadingLabel: "Ładowanie...",
  routeLoadedPrefix: "Załadowano stronę:",
} as const;
